import { Highcharts } from "extensions/highcharts";
import { _ } from "extensions/underscore";

import { toHex } from "common/colors";
import { accounting } from "common/utils";
import { v2 } from "common/config/api";

import { DefaultTypeConfig } from "./default";

export const average_ticket = function(options) {
    const opts = {
        metric: "sales",
        ...options
    };
    
    let totals;
    
    // TODO: support more than just sales
    if (opts.metric === "sales") {
        totals = {
            sales_count: _.partial(accounting.sales.getTotalValue, _, "count"),
            sales_amount: _.partial(accounting.sales.getTotalValue, _, "amount")
        };
    } else {
        throw new Error("Only sales average_ticket is supported so far...");
    }
    
    return new DefaultTypeConfig({}, {
        totals,
        api_endpoint(pivot = "date_time") {
            return v2.settlements.byPivot(Array.isArray(pivot) ? pivot : [pivot]);
        },
        quick: {
            chart: {
                type: "AreaLine",
                series: [{
                    type: "area",
                    pointFormat: [DefaultTypeConfig.date_unix, accounting.sales.averageTicket],
                    extend: {
                        fillColor: Highcharts.Color(toHex("canvas-white")).setOpacity(0.15).get("rgba"),
                        color: toHex("canvas-white")
                    }
                }]
            },
            data: {
                widgetValueTemplate: `<div class='rate'>{{ data.averageTicket }}</div>
                                      <div class='right-column'>
                                            <div class='sales-amount'>
                                                <div class='sales-amount-label'>{{ strings.salesAmount }}</div>
                                                <div class='sales-amount-value'>{{ data.salesAmount }}</div>
                                            </div>
                                            <div class='bottom'>
                                                <div class='count-label'>{{ strings.salesCount }}</div>
                                                <div class='count-value'>{{ data.salesCount }}</div>
                                            </div>
                                      </div>`,
                widgetValueTemplateData: {
                    averageTicket: {
                        value: accounting.sales.averageTicket,
                        type: "amount"
                    },
                    salesCount: {
                        value: "sales_count",
                        type: "number"
                    },
                    salesAmount: {
                        value: "sales_amount",
                        type: "amount"
                    }
                }
            }
        }
    });
};
